'use client';

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarRail,
} from '@/components/ui/sidebar';
import NavigationSection from './navigation-section';
import { AuthSection } from './auth-section';

export function AppSidebar() {
  return (
    <Sidebar
      collapsible='icon'
      className='hidden lg:flex lg:flex-col lg:border-r'
    >
      <SidebarContent className='flex-grow flex flex-col'>
        <NavigationSection />
      </SidebarContent>

      <SidebarFooter>
        <AuthSection />
      </SidebarFooter>

      <SidebarRail />
    </Sidebar>
  );
}
